import { lazy } from 'react'

export const MealsPerDayV1 = lazy(() => import('./v1/MealsPerDayV1'))
